module.exports = __webpack_public_path__ + "img/second_img.1e1c9107.png";